<template>
  <pop-up-layout
    :title="localization.title"
    :description="localization.subtitle"
    :loading="loading"
    :saving="waitingForLoad"
    :disabled="!cambiado"
    @volver="cerrarPopup()"
  >
    <Alerts></Alerts>
    <v-col cols="12">
      <v-row class="pl-6" style="margin-bottom: -20px;">
        <v-col cols="6" ></v-col>
        <v-col cols="3">
            <v-checkbox
                v-model="marcarProvincias" id="marcarProvincias"
                :label="localization.todasLasProvincias"
                color="primary"
                hide-details
                @change="marcarDesmarcarTodasProvincias()"
            />
        </v-col>
        <v-col cols="3">
            <v-checkbox
                v-model="marcarSectores" id="marcarSectores"
                :label="localization.todosLosSectores"
                color="primary"
                hide-details
                @change="marcarDesmarcarTodosSectores()"
            />
        </v-col>
      </v-row>
      <v-row class="pl-6">
        <v-col cols="6" md="6">
          <v-text-field
            v-model="search" id="search"
            :label="localization.buscar"
            @click="borrarSeleccionados()"
          />
        </v-col>
        <v-col cols="3" md="3">
            <v-autocomplete
              v-model="regionSelected" id="regionSelected"
              :no-data-text="$t('sinDatos')"
              :items="provincias"
              :label="localization.segunLista"
              multiple
              clearable
              @change="borrarSeleccionados()"
              @click:clear="marcarProvincias = false"
            />
        </v-col>
        <v-col cols="3" md="3">
            <v-autocomplete
              v-model="sectorSelected" id="sectorSelected"
              :no-data-text="$t('sinDatos')"
              :items="sectores"
              :label="localization.segunLista"
              item-value="id"
              item-text="nombre"
              multiple
              clearable
              @change="borrarSeleccionados()"
              @click:clear="marcarSectores = false"
            />
        </v-col>
      </v-row>
      <v-row class="pl-6">
          <v-checkbox v-if="multiple"
            v-model="seleccionarTodosLosResultados" id="seleccionarTodosLosResultados"
            :label="localization.seleccionarTodosLosResultados"
            color="primary"
            hide-details
            @change="marcarDesmarcarTodasPromociones()"
          />
      </v-row>
      <v-row justify="center" class="px-6">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :search="search"
            :items="promociones"
            item-key="code"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20],
              'items-per-page-text': $t('filasPorPagina'),
            }"
            :items-per-page="5"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.code"
                  @click="(item.selected == '1' && item.actorId != null && item.actorId != usuario.id) ? false : seleccionarPromocion(item)"
                  :style="(item.selected == '1' ? 'background-color: lightgray;' : '') + ((item.selected == '1' && item.actorId != null && item.actorId != usuario.id) ? 'cursor: not-allowed' : 'cursor: pointer')"
                  :disabled="item.selected == '1' && item.actorId != null &&  item.actorId != usuario.id"
                >
                  <td class="text-xs-left">{{ item.code + " - " + item.name }}</td>
                  <td class="text-xs-left">{{ item.region }}</td>
                  <td class="text-xs-left">{{ item.sector }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="multiple">
        <v-btn
          color="primary"
          @click="confirmar()"
        >
          {{localization.confirmButton}}
        </v-btn>
      </v-row>
    </v-col>
    
  </pop-up-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import Alerts from '@/components/Alerts'

export default {
  components: {
    Alerts
  },
  mixins: [rulesMixin],
  props: {
    yaSeleccionado: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    idProveedor: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      waitingForLoad: false,
      loading: false,
      search: null,
      selected: [],
      items: [],
      seleccionarTodosLosResultados: false,
      regionSelected: [],
      sectorSelected: [],
      marcarProvincias: false,
      marcarSectores: false
    }
  },
  async created () {
    try {
      this.loading = true
      this.selected = this.selected == 1 ? this.promociones.filter(x => {
        return this.selected.some(y => {
            return x.id === y.id
        })
      }) : []
      this.loading = false
    } catch (error) {
      console.log('error', error)
      this.addAlert({ texto: this.$t('errorCargarPromociones'), color: 'error' })
    }
  },
  computed: {
    ...mapGetters({
      getConfiguracion: 'configuracion/getConfiguracion',
      getPromotionsProvider: 'gestion/getPromotionsProvider'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    localization () {
      return this.$t('popUpSeleccionarPromociones')
    },
    headers () {
      return [
        {text: this.localization.headerCodigo, value: 'nombreCompleto', sortable: true, align: 'LEFT'},
        {text: this.localization.headerRegion, sortable: false, align: 'LEFT'}, 
        {text: this.localization.headerSector, sortable: false, align: 'LEFT'}
      ]
    },
    promociones () {
      if (this.$store.state.gestion.promotionsProvider) {
          let promociones = []
           if(this.regionSelected.length > 0 || this.sectorSelected.length > 0) {
                this.$store.state.gestion.promotionsProvider.forEach(promocion => {
                  if ( (this.regionSelected.length > 0 && this.sectorSelected.length > 0) && this.regionSelected.includes(promocion.region) && this.sectorSelected.includes(promocion.sectorCode) ) {
                    promociones.push(promocion)
                  }
                  else if ( (this.regionSelected.length > 0 && this.sectorSelected.length == 0) && this.regionSelected.includes(promocion.region) ) {
                    promociones.push(promocion)
                  }
                  else if ( (this.regionSelected.length == 0 && this.sectorSelected.length > 0) && this.sectorSelected.includes(promocion.sectorCode) ) {
                    promociones.push(promocion)
                  }  
                });  
                return promociones.map(x => {
                    return {
                    ...x,
                    selected: '1',
                    nombreCompleto: x.code + ' - ' + x.name
                    }
                })
           }
           else {
               return this.$store.state.gestion.promotionsProvider.map(x => {
                    return {
                    ...x,
                    nombreCompleto: x.code + ' - ' + x.name
                    }
                })
           }
          
      }
      return []
    },
    provincias () {
      let provincias = []
      if (this.$store.state.gestion.promotionsProvider) {
        this.$store.state.gestion.promotionsProvider.forEach(promocion => {
            if ( promocion.region !== null && promocion.region.trim() != "" && !provincias.includes(promocion.region)) {
                provincias.push(promocion.region)
            }
        })   
      }
      return provincias
    },
    sectores () {
      let sectores = []
      if (this.$store.state.gestion.promotionsProvider) {
        this.$store.state.gestion.promotionsProvider.forEach(promocion => {
            if ( promocion.sector !== null && promocion.sector.trim() != "" && !sectores.includes(promocion.sector)) {
                if ( sectores.filter(x => x.id === promocion.sectorCode).length == 0 ) {
                  sectores.push( { id: promocion.sectorCode, nombre: promocion.sector })
                }
            }
        });   
      }
      return sectores
    },
    cambiado () {
      return this.yaSeleccionado !== this.selected
    }
  },
  methods: {
    ...mapMutations({
      setPromotionSelected: 'gestion/setPromotionSelected'
    }),
    ...mapActions({
      addAlert: 'alerts/add',
      setPromotionsProvider: 'gestion/setPromotionsProvider'
    }),
    seleccionarPromocion (promocion) {
      this.selected = this.$store.state.gestion.promotionsProvider.filter(x => x.selected == '1')
      if (this.multiple) {
        if (this.selected.some(x => {
            return x.id === promocion.id
        })) {
          let arrSelected = []
          this.selected.forEach(i => {
            if ( i.id != promocion.id ) {
              arrSelected.push(i)
            }
          });
          this.selected = arrSelected
        } else {
          this.selected.push(promocion)
        }
        this.updatePromocionesSeleccionadas()
      } else {
        this.$emit('selected', [promocion])
        this.$parent.$parent.sheet = true
        this.$parent.hide()
      }
      console.log(this.selected)
    },
    confirmar () {
      this.selected = this.promociones.filter(x => x.selected == '1')
      this.$emit('selected', this.selected )
      this.$parent.$parent.sheet = true
      this.$parent.hide()
    },
    marcarDesmarcarTodasPromociones () {
        let promociones = []
        if (this.seleccionarTodosLosResultados === true) {
            this.selected = []
            promociones = this.promociones
            promociones.forEach(promocion => {
                this.selected.push(promocion)
            });
        }
        else {
            this.selected = []
        }
        this.updatePromocionesSeleccionadas()
    },
    marcarDesmarcarTodasProvincias () {
        this.borrarSeleccionados()
        let provincias = []
        let promociones = []
        if (this.marcarProvincias === true) {
            this.regionSelected = []
            provincias = this.provincias
            provincias.forEach(provincia => {
                this.regionSelected.push(provincia)
            });
        }
        else {
            this.regionSelected = []
        }
        this.selected = []
        promociones = this.promociones
        promociones.forEach(promocion => {
          if ( this.regionSelected.includes(promocion.region) )
            this.selected.push(promocion)
        });
        this.updatePromocionesSeleccionadas()
    },
    marcarDesmarcarTodosSectores () {
        this.borrarSeleccionados()
        let sectores = []
        let promociones = []
        if (this.marcarSectores === true) {
            this.sectorSelected = []
            sectores = this.sectores
            sectores.forEach(sector => {
                this.sectorSelected.push(sector.id)
            });
        }
        else {
            this.sectorSelected = []
        }
        this.selected = []
        promociones = this.promociones
        promociones.forEach(promocion => {
          if ( this.sectorSelected.includes(promocion.sectorCode) )
            this.selected.push(promocion)
        });
        this.updatePromocionesSeleccionadas()
    },
    updatePromocionesSeleccionadas() {
      // let promociones = []
      this.$store.state.gestion.promotionsProvider.forEach(promocion => {
        let selected = '0'
        if ( this.selected.some(x => x.id === promocion.id) ) {
          selected = '1'
        }
        this.setPromotionSelected({ id: promocion.id, selected: selected })
        // promociones.push(promocion)
      });
      // this.setPromotionsProvider(promociones)
    },
    borrarSeleccionados () {
      this.selected = []
      this.seleccionarTodosLosResultados = false
      this.updatePromocionesSeleccionadas()
    },
    cerrarPopup() {
      this.$parent.hide()
      this.$parent.$parent.sheet = true
    }
  }
}
</script>

<style scoped>
  .info-tooltip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
    margin-bottom: 0px;
  }
</style>